import { WithdrawalsFilters } from './types';

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const DEFAULT_FILTERS: WithdrawalsFilters = {
  search: '',
  status: 'all',
};

export const STATUS_COLORS = {
  pending: {
    bg: '#FEF3C7',
    text: '#92400E',
    label: 'Ожидание'
  },
  paid: {
    bg: '#D1FAE5',
    text: '#065F46',
    label: 'Оплачено'
  },
  cancel: {
    bg: '#FEE2E2',
    text: '#991B1B',
    label: 'Деактивирован'
  }
} as const;

export const ROLE_COLORS = {
  new: {
    bg: 'rgba(23, 201, 100, 0.2)',
    text: '#17C964'
  },
  base: {
    bg: '#EEEEEF',
    text: '#71717A'
  },
  pro: {
    bg: '#11181C',
    text: '#FFFFFF'
  },
  expert: {
    bg: 'rgba(120, 40, 200, 0.2)',
    text: '#7828C8'
  }
} as const;
